<template>
  <div class="bg-white">
    <div class="margin-bottom-sm flex align-center justify-between">
      <div class="flex align-center">
        <div class="flex align-center margin-right-sm">
          <span>文件名称：</span>
          <el-input v-model="searchName" placeholder="请输入文件名称" class="flex-sub"></el-input>
        </div>

        <el-button type="primary" @click="hanldSearch">搜索</el-button>
      </div>
      <el-button type="primary" @click="fileDialog = true"  v-if="user.power===5">发布文件</el-button>
    </div>
    <el-table
        :data="fileList"
        header-row-class-name="table-header"
        row-class-name="table-row"
        alig="center"
        border
        style="width: 100%"
    >
      <el-table-column width="70" type="index" align="center" label="序号">
      </el-table-column>
      <el-table-column label="文件名称" prop="name"></el-table-column>
      <el-table-column width="150" label="更新时间" prop="update_time"></el-table-column>
      <el-table-column width="300" label="操作">
        <template slot-scope="scope">
          <div class="table-operate">
            <el-link :href="downUrl + '/' + scope.row.url" target="_blank">
              <el-button
                  size="small"
                  type="primary"
              >预览
              </el-button>
            </el-link>
            <el-link :href="downUrl + '/Index/Article/articleDownload?id=' + scope.row.id" target="_blank"
                     class="margin-lr-xs">
              <el-button
                  size="small"
                  type="primary"
              >下载
              </el-button>
            </el-link>
            <el-button
                 v-if="user.power===5"
                size="small"
                type="primary"
                @click="editItem(scope.row)"
            >编辑
            </el-button>
            <el-button
                 v-if="user.power===5"
                size="small"
                type="primary"
                @click="deleteItem(scope.row.id)"
            >删除
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        v-if="fileList.length > 0"
        class="page-all"
        background
        @current-change="getFileList"
        :current-page.sync="page"
        :page-size="limit"
        layout="prev, pager, next, jumper"
        :total="total"
    >
    </el-pagination>
    <fileDialog
        :setId="setId"
        :setItem="setItem"
        :fileDialog="fileDialog"
        :type="1"
        @cancelDialog="cancelDialog"
    />
  </div>
</template>

<script>
import {articleList, articleDel} from "@/api/common";
import {zhDate} from "@/utils/utils";
import {ONLINEHOST, QAHOST} from "@/config";
import fileDialog from "@/views/pages/dialog/fileDialog";

export default {
  name: "share-files",
  data() {
    return {
      downUrl: process.env.NODE_ENV === 'production' ? ONLINEHOST : QAHOST,
      searchName: '',
      page: 1,
      limit: 10,
      total: 0,
      fileList: [],
      fileDialog: false,
      setId: 0,
      setItem: {},
    }
  },
  created() {
    this.$emit("setIndex", this.$route.path, "物业合同", false);
    this.getFileList()
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  components: {
    fileDialog
  },
  methods: {
    //  文件编辑后回调
    cancelDialog(val) {
      if (val) {
        this.setId = 0;
        this.setItem = {};
        this.fileDialog = false;
        this.getFileList();
      } else {
        this.setId = 0;
        this.setItem = {};
        this.fileDialog = false;
      }
    },
    //  编辑
    editItem(item) {
      this.fileDialog = true
      this.setId = item.id
      this.setItem = item
    },
    //  删除文件
    deleteItem(id) {
      this.$confirm('您确定要删除该文件吗？', "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureDelete(id);
      });
    },
    async sureDelete(id) {
      let _state = await articleDel(id);
      if (this.fileList.length === 1 && this.page > 1) {
        this.page--;
      }
      this.getFileList();
      this.$message.success(_state.info);
    },
    //  搜索
    hanldSearch() {
      this.page = 1
      this.getFileList()
    },
    //  获取文件列表
    async getFileList() {
      let _list = await articleList(this.searchName, 1, this.page, this.limit)
      _list.data.map(item => {
        item.update_time = zhDate(item.create_time * 1000)
      })
      this.fileList = _list.data
      this.total = _list.total_number
    },
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">

</style>
